export default "__VITE_ASSET__f40a79d7__"